// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'

import "./Alert.scss"


interface AlertProps {
  children?: React.ReactNode
  heading?: string
  icon?: IconDefinition
  level?: "primary" | "success" | "warning" | "danger" | "default"
}


const Alert: React.FC<AlertProps> = ({
  heading,
  icon,
  ...props
}) => {
  const level = (props.level !== undefined) ? props.level : "default"
  const classNames: string[] = ["alert", `alert-${level}`]
  return (
    <div className={classNames.join(" ")} role="alert">
      {(!icon) ? null : (
        <div style={{fontSize: "36px", height: "100%", marginRight: "11px", width: "48px"}}>
          <FontAwesomeIcon icon={icon}/>
        </div>
      )}
      <div>
        {(!!heading) ? (<h4 className="alert-heading">{heading}</h4>) : null}
        {props.children}

      </div>
    </div>
  )
}


export { Alert }